import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, IButtonColumn, ICustomTable, IDataColumn, IHeader, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { TablasDinamicasConfigService } from '../../../services/database/tablas-dinamicas-config.service';
import { IColumnDinamico, TablasDinamicasConfig, TablasDinamicasDatosDto, UpdateFilaTablaDinamicaDto } from '../../../shared/interfaces/database/tramites_automaticos';
import { getColumnAlignment } from './dataset-utils';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Menu, MenuModule } from 'primeng/menu';
import saveAs from 'file-saver';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { GetDatasetDocumentosComponent } from './get-dataset-documentos.component';
import { ColumnType } from './dataset-dinamico-columnas';
import { DatasetVisualizarDocumentosComponent } from './dataset-visualizar-documentos.component';
import { JSONParser } from '@amcharts/amcharts5';
import { GetDatasetHistoricoComponent } from './get-dataset-historico.component';

@Component({
  selector: 'app-get-dataset-dinamico-datos',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CustomTableComponent,
    ConfirmPopupModule, DialogModule, CustomTitle,
    FormGroupErrorMessageComponent, InputTextModule, ButtonModule,
    MenuModule, FileUploadModule, TranslateModule,
    GetDatasetDocumentosComponent, DatasetVisualizarDocumentosComponent, GetDatasetHistoricoComponent
  ],
  providers: [ConfirmationService],
  template: `
<p-menu #menu [model]="exportTypes" [popup]="true" appendTo="body"/>
<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>
<ng-template #tableRowexpansion let-data>
  <app-get-dataset-documentos [tablaDinamicaConfig]="tablaDinamicaConfig" [filaId]="data.id"></app-get-dataset-documentos>
</ng-template>

<app-dataset-visualizar-documentos></app-dataset-visualizar-documentos>

<section>
  <form [formGroup]="formDataset" (submit)="onSubmit()">

    <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
      [resizable]="true" [maximizable]="true"
      [breakpoints]="{'960px': '100vw'}" [style]="{width: '70vw'}" >

      <ng-template pTemplate="header">
        <CustomTitle [title]="formTitle" />
      </ng-template>

      <ng-template pTemplate="content">
        <main class="grid formgrid p-fluid">

          <ng-container *ngFor="let column of datasetColumnas">
            @if(column.editable){
              <div class="field col-12 md:col-6">
                <label class="ml-3" [for]="column.name">
                  {{column.displayName}}
                </label>
                <input pInputText [formControlName]="column.name" [id]="column.name" type="text"/>
                <ng-container *ngIf="formDataset.get(column.name)?.invalid && formDataset.get(column.name)?.touched">
                  <app-form-group-error-message [control]="formDataset.get(column.name)"></app-form-group-error-message>
                </ng-container>
              </div>
            }
          </ng-container>

          <div class="field col-12" *ngIf="permiteDocumentos">
            <div>
                <b>{{'common.documentos' | translate}}:</b>
            </div>
            <div>
                <p-fileUpload #documentos
                    mode="advanced"
                    accept="application/pdf,image/*"
                    [maxFileSize]="uploadFileSize"
                    [chooseLabel]="'msg.agregarDocumento' | translate"
                    chooseIcon="pi pi-upload"
                    [customUpload]="true"
                    [auto]="true"
                    [multiple]="true">
                </p-fileUpload>
            </div>
          </div>
        </main>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="field col-12">
          <div class="flex justify-content-end">
            <button pButton type="submit" [label]="trans.guardar" icon="pi pi-save" iconPos="right" class="tax-app-button"
              style="width: 16rem;" [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
          </div>
        </div>
      </ng-template>
    </p-dialog>

  </form>
</section>
<app-get-dataset-historico></app-get-dataset-historico>
  `
})
export class GetDatasetDinamicoDatosComponent implements OnInit {
  @Input() tablaDinamicaId!: number;
  @Input() datasetNombre!: string;
  @Input() tablaDinamicaConfig!: TablasDinamicasConfig;

  readonly uploadFileSize: number = 1024 * 1024

  role = AccessRole;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild('menu') menu !: Menu;
  exportTypes !: MenuItem[];

  get permiteDocumentos(): boolean {
    return this.tablaDinamicaConfig ? this.tablaDinamicaConfig.permiteDocumentos : false;
  }

  //Edit form
  datasetColumnas: IColumnDinamico[] = [];
  datasetDatos !: Record<string, any>[]; // esto es para mostrar los valores originales de la tabla cuando existen fk en la tabla
  displayModal = false;
  formDataset !: FormGroup;
  formTitle = 'Editar';
  private _editRow: any;
  get isNewForm(): boolean {
    return this._editRow === undefined;
  }

  @ViewChild('documentos') documentos!: FileUpload;
  @ViewChild(DatasetVisualizarDocumentosComponent) visualizarDocumentos!: DatasetVisualizarDocumentosComponent;
  @ViewChild(GetDatasetHistoricoComponent) historico !: GetDatasetHistoricoComponent;

  constructor(private readonly _tsc: TablasDinamicasConfigService, private readonly _lps: LoadingPanelService, private readonly _cs: ConfirmationService,
    private readonly _t: TranslateService, private readonly _ms: MessageService, public readonly ls: LocalService,
    private readonly _fb: FormBuilder
  ) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.exportTypes = [
        {
          label: this.trans.descargarExcel,
          icon: 'pi pi-file-excel',
          command: () => this.descargarComo('xlsx')
        },
        {
          label: this.trans.descargarCsv,
          icon: 'pi pi-file',
          command: () => this.descargarComo('csv')
        }
      ];
    });
    this.getTablasDinamicas();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      success: this._t.get('common.success'),
      confirmarEliminarFila: this._t.get('msg.confirmarEliminarFila'),
      filaEliminadaExitosamente: this._t.get('msg.filaEliminadaExitosamente'),
      editar: this._t.get('common.editar'),
      guardar: this._t.get('form.button.guardar'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      advertencia: this._t.get('common.advertencia'),
      nuevo: this._t.get('common.nuevo'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      nuevoRegistro: this._t.get('msg.nuevoRegistro'),
      editarRegistro: this._t.get('msg.editarRegistro'),
      registroGuardadoExitosamente: this._t.get('msg.registroGuardadoExitosamente'),
      requiereRolSeguridad: this._t.get('msg.requiereRolSeguridad'),
      descargarExcel: this._t.get('msg.descargarExcel'),
      descargarCsv: this._t.get('msg.descargarCsv'),
      documentos: this._t.get('common.documentos')
    }));
  }

  private getTablasDinamicas(): void {
    this._lps.show(true);
    this._tsc.consultarDatosTablaDinamica(this.tablaDinamicaId, false).subscribe((data: TablasDinamicasDatosDto) => {
      this.datasetColumnas = data.datasetColumnas;

      let columnsTable: (IDataColumn | IButtonColumn<any>)[] = [];

      if(this.tablaDinamicaConfig.permiteDocumentos){
        const expand = {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        } as IButtonColumn<any>;
        columnsTable.push(expand);
      }

      this.datasetColumnas.forEach((column) => {

        switch (column.type as ColumnType) {
          case ColumnType.FormDocument:
            columnsTable.push({
              field: column.name,
              header: column.displayName,
              label: this.trans.documentos,
              icon: 'pi pi-folder-open',
              class: 'button-edit p-button-outlined pt-2 pb-2',
              width: '0rem',
              buttonType: ButtonColumnType.CUSTOM,
              onClick: (event: Event, data: any, fieldName?: string) => this.openDocuments(event, data, fieldName)
            });
            break;
          default:
            columnsTable.push({
              field: column.name,
              header: column.displayName,
              columnFilter: true,
              class: 'font-13 ' + getColumnAlignment(column),
              columnmHeader: {
                class: 'color-blue-2 font-13 font-bold text-left',
              },
              dataType: DataColumnType.CUSTOM,
              format: column.format
            });
          break;
        }

      });

      columnsTable.push(
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-1',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: any) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pr-1 pl-0',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: any) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-download',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.btnDescargar(event),
            disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          },
          headerTooltip: {
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_TRAM)
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: any) => this.deleteRowConfirm(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          },
          headerTooltip: {
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_TRAM)
          }
        },
      );

      this.customTable = {
        header: {
        } as IHeader,
        columns: columnsTable,
        settings: {
          table: {
            rows: 10,
            scrollable: true
          }
        }
      } as ICustomTable;

      //La informacion de la tabla se tiene que actualizar antes cargar el data
      setTimeout(() => {
        this.customTableComponent.data = data.datos;
        this._lps.hide();
        this.configureForm();
      }, 1);

    });
    this._tsc.consultarDatosTablaDinamica(this.tablaDinamicaId, true).subscribe((data: TablasDinamicasDatosDto) => {
      this.datasetDatos = data.datos;
    });
  }

  abrirHistorial(data: any): void {
    this.historico.show(this.tablaDinamicaConfig.id, data.id);
  }
  //#region Edit Row

  //#region Form
  private configureForm() {
    const formGroup: { [key: string]: any } = {};

    this.datasetColumnas.forEach((column: IColumnDinamico) => {
      if (column.editable) {
        formGroup[column.name] = [null, [Validators.maxLength(255)]];
      }
    });

    this.formDataset = this._fb.group(formGroup);
  }

  resetForm() {
    this.formDataset.reset();
    if (this.documentos) {
      this.documentos.clear();
    }
  }

  openNewModal() {
    this.displayModal = true;
    this.resetForm();
    this.formTitle = this.trans.nuevoRegistro;
    this._editRow = undefined;
  }

  openEditModal(data: any) {
    data = this.datasetDatos.find(d => d["id"] === data.id);
    this.displayModal = true;
    this.resetForm();
    this.formTitle = this.trans.editarRegistro;
    this._editRow = data;

    if (data) {
      const formValues: any = {};

      this.datasetColumnas.forEach((column: IColumnDinamico) => {
        if (data[column.name] !== undefined) {
          formValues[column.name] = data[column.name];
        }
      });

      this.formDataset.patchValue(formValues);
    }
  }

  onSubmit() {
    if (this.formDataset.invalid) {
      Utils.markAllFormControlsAsTouched(this.formDataset);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCampos });
      return;
    }

    let rowData: Record<string, any> = {};
    this.datasetColumnas.forEach((column: IColumnDinamico) => {
      rowData[column.name] = this.formDataset.get(column.name)?.value;
    });

    if (this.isNewForm) {
      this.insertarFilaDataset(rowData);
    } else {
      const updateFilaTablaDinamicaDto: UpdateFilaTablaDinamicaDto = {
        filaId: this._editRow.id,
        filaActualizada: rowData
      };

      this.editarFilaDataset(updateFilaTablaDinamicaDto);
    }
    this.documentos.clear();
  }

  //#endregion form

  private editarFilaDataset(request: UpdateFilaTablaDinamicaDto) {
    this._lps.show(true);
    this._tsc.editarFilaDataset(this.tablaDinamicaId, request, this.documentos?.files).subscribe(() => {
      this.getTablasDinamicas();
      this._ms.add({ severity: 'success', summary: this.trans.success, detail: this.trans.registroGuardadoExitosamente });
      this._lps.hide();
      this.displayModal = false;
    });
  }

  private insertarFilaDataset(request: Record<string, any>) {
    this._lps.show(true);
    this._tsc.insertarFilaDataset(this.tablaDinamicaId, request, this.documentos?.files).subscribe(() => {
      this.getTablasDinamicas();
      this._ms.add({ severity: 'success', summary: this.trans.success, detail: this.trans.registroGuardadoExitosamente });
      this._lps.hide();
      this.displayModal = false;
    });
  }

  //#region Delete Row
  private deleteRowConfirm(event: Event, data: any): void {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.trans.confirmarEliminarFila,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._lps.show(true);
        this.deleteDatasetRow(data);
      },
      reject: () => {

      }
    });
  }

  private deleteDatasetRow(data: any) {
    this._tsc.eliminarFilaTablaDinamica(this.tablaDinamicaId, data.id).subscribe(() => {
      this.getTablasDinamicas();
      this._ms.add({ severity: 'success', summary: this.trans.success, detail: this.trans.filaEliminadaExitosamente });
      this._lps.hide();
    });
  }
  //#endregion

  //#region Descargar Dataset
  private btnDescargar(event: Event) {
    this.menu.toggle(event);
  }

  private descargarComo(formato: 'xlsx' | 'csv') {
    this._lps.show(true);
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}${String(today.getMonth() + 1).padStart(2, '0')}${today.getFullYear()}`;
    const fileName = `${this.datasetNombre}-${formattedDate}`;

    this._tsc.descargarDataset(this.tablaDinamicaId, formato).subscribe({
      next: (response: Blob) => {
        this._lps.hide();
        saveAs(response, fileName);
      }
    });
  }
  //#endregion

  //#region Visualizar Documentos
  openDocuments(event: Event, data: any, fieldName?: string): void {
    const name = fieldName ?? '';
    const column = JSONParser.parse(data[name]);
    this.visualizarDocumentos.openModal(this.tablaDinamicaConfig.id, data.id, name, column);
  }

  //#endregion Visualizar Documentos
}
